import { render, staticRenderFns } from "./print-edit.vue?vue&type=template&id=c54b755c&scoped=true"
import script from "./print-edit.vue?vue&type=script&lang=js"
export * from "./print-edit.vue?vue&type=script&lang=js"
import style0 from "./print-edit.vue?vue&type=style&index=0&id=c54b755c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b755c",
  null
  
)

export default component.exports